// import { Option } from '@/data/data-models';

/*
|-------------------------------------------------------------------------------
| Your options can be defined below (refer to src/options/definition/options.js for syntax)
| Uncomment the needed import above
| See the README in this folder, or the docsify documentation for more information
|-------------------------------------------------------------------------------
*/

/*
|-------------------------------------------------------------------------------
| An example of an option
|-------------------------------------------------------------------------------
*/
// alignItems: new Option({
//     metadata: {
//         name: 'alignItems',
//         lockedOption: false,
//         groupOption: true,
//         requiredProps: [],
//         disallowedProps: [],
//         screens: [],
//     },
//
//     component: 'align-items',
// }),

export default {};
